import { render } from "./ShopStorage.vue?vue&type=template&id=4b667993"
import script from "./ShopStorage.vue?vue&type=script&lang=js"
export * from "./ShopStorage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__